import { RouteConfig } from '../../routing/types'

const ROUTE: RouteConfig = {
  name: 'tutorials-index',
  path: () => `/tutorials`,
}

export default ROUTE
